import { useAgenciesList } from '~/api/queries/agency'
import { useCurrentUserInfos } from '~/api/queries/user'

type Agency = { id: number; name: string }

type UseUserAgenciesParams = {
  enabled?: boolean
}

export const useUserAgencies = ({
  enabled = true
}: UseUserAgenciesParams = {}) => {
  const userQuery = useCurrentUserInfos()
  const userInfo = userQuery.data?.[0]
  const isAdmin = userInfo?.groups.some((g) => g.id === 1) ?? false
  const agenciesQuery = useAgenciesList(undefined, enabled && isAdmin)

  const agencies: Agency[] = !enabled
    ? []
    : isAdmin
      ? (agenciesQuery.data ?? []).map((a) => ({ id: a.id, name: a.name }))
      : [...(userInfo?.agencies ?? [])].sort((a, b) =>
          a.name.localeCompare(b.name, 'fr')
        )

  return {
    agencies,
    isLoading:
      enabled && (userQuery.isLoading || (isAdmin && agenciesQuery.isLoading))
  }
}
